export enum AdminRole {
    Admin = 'admin',
}

export enum OwnerRole {
    Company = 'owner_company',
    Admin = 'owner_admin',
    User = 'owner_user',
}

export enum GuestRole {
    Company = 'guest_company',
    Admin = 'guest_admin',
    DepartmentAdmin = 'guest_department_admin',
    User = 'guest_user',
}

export enum ContractorRole {
    Admin = 'contractor_admin',
    User = 'contractor_user',
}
export enum External_Attendee_Role {
    User = 'external_attendee_user',
}
